export default "__VITE_ASSET__CQQBfi4c__"